<template>
    <v-main id="layout-centered">
        <transition name="fade" mode="out-in">
            <slot />
        </transition>
    </v-main>
</template>


<script>
    export default {
        name: "CenteredLayout",
        data: () => ({}),
    }
</script>

